module.exports = __webpack_public_path__ + "img/refresh.be506a51.svg";